import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'scrollbar-hidden flex w-[calc(100%+24px)] max-md:-mx-3 max-md:overflow-x-scroll',
    tagGroup: 'shrink-0 flex-nowrap max-md:px-3 md:flex-wrap'
  }
});
